import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteBenefitFragment = contentfulGql`#graphql
  ${imageFragment}
  fragment EntWebsiteBenefit on EntWebsiteBenefit {
    slug
    headline
    headlineColor
    subhead
    subheadColor
    ctaText
    ctaTarget
    ctaColor
    image {
      ...Image
    }
  }
`;

export const entWebsiteBenefitListFragment = contentfulGql`#graphql
  ${imageFragment}
  ${entWebsiteBenefitFragment}
  fragment EntWebsiteBenefitList on EntWebsiteBenefitList {
    slug
    title
    benefitsCollection(limit: 3) {
      items {
        ...EntWebsiteBenefit
      }
    }
  }
`;

export const entWebsiteBlockBenefitListQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteBenefitListFragment}
  query entWebsiteBlockBenefitList($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteBenefitList
      }
    }
  }
`;
